import {
    DATE_TIME_FORMAT_NAME_MODEL,
    DEFAULT_LATITUDE,
    DEFAULT_LONGITUDE,
    getDateFormat, getDateLongAsIs,
    isBeforeToday
} from '../../../../../Apis/functions';
import {
    BackslashSvg, DoneChip,
    IconAreaTable,
    IconTraffic,
    NumberTwoSvg,
    PercentSvg,
} from '../../../../../components/buttons/IconButtons';
import { STATUS_MODEL } from '../../../../../enums/statusEnum';
import { colors } from '../../../../../enums/colors';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

//Defines the available subviews within the "Traffic Fines" tab
export const TRAFFIC_FINES_VIEW_TYPE = {
    DASHBOARD: 0,
    USERS: 1,
};

export const TYPE_PAYMENT = {
    NORMAL: "NORMAL",
    CONDONATION: "CONDONATION",
};

const getFirstSteps = (fineDate, discountDate, discountApplied) => {
    return [
        {
            icon: <DoneChip />,
            backgroundColor: colors.success600,
            titleColor: colors.success600,
            subtitleColor: colors.general950,
            status: 'issued_fine',
            date: getDateFormat(fineDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth),
        },
        {
            icon: <PercentSvg />,
            backgroundColor: discountApplied ? colors.secondary500: colors.shades700 ,
            titleColor: discountApplied ? colors.secondary500: colors.shades700 ,
            subtitleColor: colors.general950,
            status: 'discount_window',
            date: `${getDateFormat(fineDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)} - ${getDateFormat(discountDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}`,
        }
    ]
}

export const buildFineStatusData = (
    statusId, statusScheduleId, createdAtFine, finePaymentDate,
    discountDate, paymentDate, suspendedAccountDate, discountApplied
) => {

    const statusOverdue = parseInt(statusScheduleId);
    const isPaid = parseInt(statusId) === STATUS_MODEL.PAID;
    const isOverdue = parseInt(statusScheduleId) === STATUS_MODEL.OVERDUE && !isPaid;
    const paidOnTime = isPaid && new Date(finePaymentDate).getTime() <= new Date(discountDate).getTime();

    const steps = {
        [STATUS_MODEL.ISSUED]: [
            ...getFirstSteps(createdAtFine, discountDate, discountApplied),
            ...(isPaid
                ? [{
                    icon: <DoneChip />,
                    backgroundColor: colors.success600,
                    titleColor: colors.success600,
                    subtitleColor: colors.general950,
                    status: 'fine_paid',
                    date: getDateFormat(finePaymentDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth),
                }]
                : []),
            ...(!paidOnTime
                ? [{
                    icon: isPaid ? <DoneChip /> : <NumberTwoSvg />,
                    backgroundColor: isPaid ? colors.success600 : colors.shades400,
                    titleColor: isPaid ? colors.success600 : colors.shades700,
                    subtitleColor: isPaid ? colors.general950 : colors.shades500,
                    status: 'due_date_payment',
                    date: getDateFormat(paymentDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth),
                }]
                : [])
        ],
        [STATUS_MODEL.OVERDUE]: [
            ...getFirstSteps(createdAtFine, discountDate, discountApplied),
            {
                icon: isPaid ? <DoneChip /> : <NumberTwoSvg />,
                backgroundColor: isPaid ? colors.success600 : colors.shades700,
                titleColor: isPaid ? colors.success600 : colors.shades700,
                subtitleColor: colors.general950,
                status: 'due_date_payment',
                date: getDateFormat(paymentDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth),
            },
            ...(isPaid
                ? [{
                    icon: <DoneChip />,
                    backgroundColor: colors.success600,
                    titleColor: colors.success600,
                    subtitleColor: colors.general950,
                    status: 'fine_paid',
                    date: getDateFormat(finePaymentDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth),
                }]
                : []),
            {
                icon: <BackslashSvg />,
                backgroundColor: isOverdue ? colors.errorCode600 : colors.shades400,
                titleColor: isOverdue ? colors.errorCode600 : colors.shades600,
                subtitleColor: colors.general950,
                status: 'suspended_account',
                date: getDateFormat(suspendedAccountDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth),
            }
        ],
    };

    return steps[statusOverdue] || [];
};

export const TAB_OPTIONS = {
    FINES: "FINES",
    GEOFENCES: "GEOFENSES"
}

export const TrafficFinesTabs = [
    {
        id: 0,
        key: TAB_OPTIONS.GEOFENCES,
        translation: "geofences",
        icon: <IconAreaTable className='h-18px w-18px' />
    },
    {
        id: 1,
        key: TAB_OPTIONS.FINES,
        translation: "fines",
        icon: <IconTraffic className='h-18px w-18px' />
    },

];


export const CREATE_FINE_MODEL = {
    id: null,
    geofence: null,
    fineType: null,
    dateTime: null,
    speed: null,
    description: null,
    clear: function () {
        this.geofence = null;
        this.fineType = null;
        this.dateTime = null;
        this.description = null;
        return this;
    },
    isValid: function (users, locations) {
        return (
            this.geofence !== null &&
            this.fineType !== null &&
            this.dateTime !== null &&
            this.speed !== null &&
            this.description !== null &&
            users?.length > 0 &&
            locations?.length > 0
        )
    },
    toAdd: function (userId, latitude, longitude) {
        return {
            geofenceId: this.geofence,
            fineTypeId: this.fineType,
            fineDate: new Date(this.dateTime).getTime(),
            description: this.description,
            speed: this.speed,
            userId: userId,
            latitude: latitude,
            longitude: longitude,
        }
    }
}

export const TRAFFIC_FINES_MODEL = {
    userId: null,
    start: null,
    end: null,
    toRegister: function () {
        let startOfDay = this.start ? new Date(this.start) : new Date();
        let endOfDay = this.end ? new Date(this.end) : new Date();

        startOfDay.setHours(0, 0, 0, 0);
        endOfDay.setHours(23, 59, 59, 999);

        return {
            userId: this?.userId,
            start: getDateLongAsIs(startOfDay),
            end: getDateLongAsIs(endOfDay)
        }
    },
    setRange: function (start, end) {
        let startOfDay = start ? new Date(start) : new Date();
        let endOfDay = end ? new Date(end) : new Date();

        startOfDay.setHours(0, 0, 0, 0);
        endOfDay.setHours(23, 59, 59, 999);

        return {
            start: getDateLongAsIs(startOfDay),
            end: getDateLongAsIs(endOfDay)
        }
    },
};

export const FINES_LOCATION_MODEL = {
    userId: null,
    latitude: DEFAULT_LATITUDE,
    longitude: DEFAULT_LONGITUDE,
    start: null,
    end: null,
}
